<template>
	<div>
		<div class="pc">
			<el-carousel height="100vh">
				<el-carousel-item v-for="(item,index) in data" :key="index">
					<a href="javascript:;" @click="url(item.url)">
						<div class="item" :style="{backgroundImage:'url(' + item.image + ')'}"></div>
						<!-- <img :src="item.image" class="item"> -->
					</a>
				</el-carousel-item>
			</el-carousel>
		</div>
	</div>
</template>

<script>
	import {
		common_slide
	} from '@/api/common.js';
	export default {
		name: 'commonSlide',
		data() {
			return {
				data: [],
			}
		},
		created() {
			this.get_data();
		},
		methods: {
			get_data() {
				common_slide({
					slide_id: 1
				}).then(res => {
					if (res.code == 1) {
						this.data = res.data;
					}
				});
			},

			url(path) {
				if (path.indexOf("http") != -1) {
					window.location.href = path;
				} else {
					this.$router.push(path);
				}
			}
		}
	}
</script>
<style scoped>
	.item {
		height: 100vh;
		max-width: 100%;
		min-width: 1000px;
		z-index:-10;
		zoom: 1;
		background-color: #fff;
		background-repeat: no-repeat;
		background-size: cover;
		-webkit-background-size: cover;
		-o-background-size: cover;
		background-position: center 0;
	}

	/deep/ .el-carousel__arrow--left {
		left: 100px;
	}

	/deep/ .el-carousel__arrow--right {
		right: 100px;
	}

	/deep/ .el-carousel__button {
		background-color: #8a8a8a;
		width: 50px;
		height: 4px;
	}

	/deep/ .is-active .el-carousel__button {
		/* background-color: #000; */
	}

	/deep/ .el-carousel__indicators--horizontal {
		bottom: 30px;
	}
</style>
